export default __webpack_public_path__ + "static/media/AI-home.7a9e5e61.png";